module.exports = __webpack_public_path__ + "static/img/5879_phase_function_Paper_PointsHejduk_Prediction.a3a4f29.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5879_phase_function_Paper_PointsHejduk_Prediction.png
// module id = 7mPi
// module chunks = 0